/* global $, prestashop */

$(document).ready(() => {
    console.log('recaptcha');
    $('#contact-form, #account-form').submit((event) => {
        if (document.getElementById('recaptchaResponse').value === '') {
            event.preventDefault();
            grecaptcha.ready(() => {
                grecaptcha.execute('6LdRPfMUAAAAAAb514V9QvTycqMAFgv-chnBnTOh', {action: 'homepage'}).then((token) => {
                    document.getElementById('recaptchaResponse').value = token;
                    $(event.currentTarget).submit();
                });
            });
        }
    });
});
